<h1 mat-dialog-title class="p-2 text-center">Ajout d'un contact </h1>
<div mat-dialog-content class="p-3">
    @if (!IsCreation) {
    <div>
        <div class="row">
            <mat-form-field class="col">
                <mat-select placeholder="Contact chantier" [(ngModel)]="Model" [compareWith]="compareUserWith">
                    @for (contact of ClientContactList; track contact) {
                    <mat-option [value]="contact">
                        <span>{{contact.FirstName}} {{contact.LastName}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    }
    @if (IsCreation) {
    <div>
        <div class="row">
            <mat-form-field class="col">
                <input matInput [(ngModel)]="Model.FirstName" placeholder="Prénom" required>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <input matInput [(ngModel)]="Model.LastName" placeholder="Nom" required>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <input matInput [(ngModel)]="Model.Phone" placeholder="Téléphone" required>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col mb-3">
                <input matInput #email="ngModel" id="email" name="email" type="email" pattern="([a-zA-Z0-9_.+-]+)@([a-zA-Z0-9-\.]+)(\.[a-zA-Z0-9]{2,3})$"
                    [(ngModel)]="Model.Email" placeholder="Email" required>
                @if (email.errors?.pattern) {
                <span class="error">
                    Email incorrect
                </span>
                }
            </mat-form-field>
        </div>
    </div>
    }
    <!-- <div class="row">
  <mat-form-field class="col-6 mb-3">
    <input matInput [(ngModel)]="Model.Position" placeholder="Fonction" >
  </mat-form-field>
</div> -->

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col me-1" color="primary" mat-stroked-button (throttledClick)="setCreationMode()">
            {{ IsCreation ? 'Contact existant': 'Nouveau' }}
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()">
            Ajouter
        </button>
    </div>
</div>